import { Checkbox, Col, Divider, Row } from "antd";
import cn from "classnames";
import { isEmpty, snakeCase } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
const CheckboxGroup = Checkbox.Group;
const EMPTY_COLUMNS: any[] = [];

interface IProps {
  names?: any;
  defaultColumns?: any;
  checkedColumns?: any;
}
const TemplateExportExcel: React.FC<IProps> = ({
  names,
  defaultColumns = EMPTY_COLUMNS,
  checkedColumns = EMPTY_COLUMNS,
}) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();

  const defaultCheckedList = useMemo<any[]>(
    () => Array.from(new Set<any>([...defaultColumns, ...checkedColumns])),
    [defaultColumns, checkedColumns]
  );

  const [checkedList, setCheckedList] = useState<any[]>(defaultCheckedList);
  const [indeterminate, setIndeterminate] = useState(
    !!defaultCheckedList.length && defaultCheckedList.length < names?.length
  );
  const [checkAll, setCheckAll] = useState(defaultCheckedList.length === names?.length);

  const syncColumnValues = (list: any[]) => {
    names?.forEach((name) => {
      setValue(name, list.includes(name));
    });
  };

  useEffect(() => {
    setCheckedList(defaultCheckedList);
    setIndeterminate(
      !!defaultCheckedList.length && defaultCheckedList.length < names?.length
    );
    setCheckAll(defaultCheckedList.length === names?.length);
    syncColumnValues(defaultCheckedList);
  }, [defaultCheckedList, names]);

  const onChange = (list) => {
    const nextList = Array.from(new Set<any>([...defaultColumns, ...list]));
    setCheckedList(nextList);
    setIndeterminate(!!nextList.length && nextList.length < names?.length);
    setCheckAll(nextList.length === names?.length);
    syncColumnValues(nextList);
  };

  const onCheckAllChange = (e) => {
    const nextList = e.target.checked ? names : defaultColumns;
    setCheckedList(nextList);
    setIndeterminate(e.target.checked ? false : !isEmpty(nextList));
    setCheckAll(e.target.checked);
    syncColumnValues(nextList);
  };

  // Default Columns
  const isDefault: (name: string) => boolean = (name) => {
    return defaultColumns.includes(name);
  };

  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
        >
          {t("check_all")}
        </Checkbox>
      </Col>
      <Col span={24}>
        <Divider style={{ margin: "10px 0" }} />
      </Col>
      <Col span={24}>
        <CheckboxGroup
          defaultValue={defaultColumns}
          value={checkedList}
          onChange={onChange}
        >
          <Row gutter={[14, 14]}>
            {names?.map((name) => {
              return (
                <Col key={name} span={8} style={{ minWidth: "10rem" }}>
                  <Checkbox value={name} disabled={isDefault(name)}>
                    {t(snakeCase(name))}
                  </Checkbox>
                </Col>
              );
            })}
          </Row>
        </CheckboxGroup>
      </Col>
      {names?.map((column) => {
        return (
          <Controller
            key={column}
            name={column}
            control={control}
            defaultValue={checkedList.includes(column)}
            render={({ field: { ...field } }) => {
              return (
                <>
                  <Checkbox
                    {...field}
                    checked={field.value}
                    className={cn("shadow", styles.hiden)}
                  >
                    {t("aa")}
                  </Checkbox>
                </>
              );
            }}
          />
        );
      })}
    </Row>
  );
};

export default TemplateExportExcel;
